import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const kennerOptions: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

const kennerEmergencyDescription =
  "New Orleans is only ~10 miles via I-10 — practically the same metro area. But here is the brutal irony of Kenner: Louis Armstrong New Orleans International Airport (MSY) sits squarely within city limits. Kenner residents can see commercial airliners taking off for Cancun, London, and Tokyo from their backyards — yet Louisiana's single passport agency, 10 miles away in downtown New Orleans, serves the entire state's 4.6M residents. During hurricane season (June–November), a Cat 3+ storm triggers mandatory evacuations that gridlock I-10 in both directions — the 10 miles to the New Orleans agency become impassable just when international travel becomes most urgent. When the agency closed for weeks after Katrina, Kenner residents — living next to an international airport — had zero passport agency access in the entire state. During Mardi Gras, parades and road closures in the French Quarter and CBD can turn that 10-mile drive into 2+ hours. You can watch planes leave for six continents from your living room window. You just cannot get on one without a passport — and Louisiana's single agency for 4.6M people is on the other side of gridlocked hurricane evacuation routes.";

const kennerDisclaimer =
  "Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. During hurricane season, the New Orleans passport agency may close with little notice — plan accordingly.";

export default function KennerProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Kenner"
      headingExtra="LA"
      introText="Kenner travelers — MSY airport employees, Jefferson Parish families, Louis Armstrong International travelers, and Rivertown professionals — have several options for getting a passport fast. Here is how they compare, and why most Kenner residents choose a U.S. Department of State registered passport courier for predictable, professional processing before their next flight out of MSY."
      options={kennerOptions}
      emergencyDescription={kennerEmergencyDescription}
      disclaimerText={kennerDisclaimer}
    />
  );
}